msgid ""
msgstr ""
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"POT-Creation-Date: 2025-08-14 12:05+0200\n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Language: en\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"Plural-Forms: \n"
"X-Generator: Poedit 3.6\n"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:11
msgid "safeSend.tabs.header.dbName"
msgstr "Name"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:16
msgid "safeSend.tabs.header.emails"
msgstr "Excluded email addresses"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:23
msgid "safeSend.tabs.header.actions"
msgstr "Suspicious actions"

#. js-lingui-explicit-id
#: src/pages/SafeSend/useDataGrid.ts:30
msgid "safeSend.tabs.header.status"
msgstr "Status"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/NewFeatureBanner/index.tsx:8
msgid "features.newFeatureBanner.safesend"
msgstr "<bold>⭐️ New:</bold> SafeSend, the filter for dangerous email addresses"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:73
msgid "features.footer.followEmailTrainingLink"
msgstr "https://www.mindbaz.com/solutions-e-marketing/formations-email-delivrabilite-deduplication-et-reactivation-des-inactifs/"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:85
msgid "features.footer.learnMoreLink"
msgstr "https://www.mindbaz.com/solutions-e-marketing/audits-conseils-gestion-emailing/"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:36
msgid "dashboards.menuCards.deliverability.content"
msgstr "Global view of your deliverability across all databases"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:38
msgid "dashboards.menuCards.deliverability.title"
msgstr "Deliverability Report"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:43
msgid "dashboards.menuCards.campaign.content"
msgstr "Analyze campaign and segment performance on each database"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:45
msgid "dashboards.menuCards.campaign.title"
msgstr "Campaign Statistics"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:59
msgid "dashboards.title"
msgstr "Welcome to Mindbaz Dashboards!"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:60
msgid "dashboards.description"
msgstr "Track deliverability and the performance of campaigns on your Mindbaz databases. With our dashboard \"Deliverability report\", you can keep an eye on deliverability and the reputation of your domains and IP addresses on ISPs. Analyze campaign performance as a whole or by segment with our \"Campaign Statistics\" dashboard."

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:75
msgid "dashboards.customDashboards"
msgstr "Custom Dashboards"

#. js-lingui-explicit-id
#: src/pages/Dashboards/index.tsx:105
msgid "dashboards.needCustomDashboard"
msgstr "Need a custom dashboard?"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:99
msgid "snapshot.gridPerformances.header.sentRate"
msgstr "Sent Rate"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:106
msgid "snapshot.gridPerformances.header.deliveredEmails"
msgstr "Delivered Emails"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:113
msgid "snapshot.gridPerformances.header.hardBounce"
msgstr "Hard Bounce"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:121
msgid "snapshot.gridPerformances.header.openers"
msgstr "Openers"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:128
msgid "snapshot.gridPerformances.header.clickers"
msgstr "Clickers"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:135
msgid "snapshot.gridPerformances.header.unsubscribes"
msgstr "Unsubscribes"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:145
msgid "table.labelRowsPerPage"
msgstr "Results per page:"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:147
msgid "table.labelDisplayedRowsSeparator"
msgstr "of"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useDataGrid.tsx:150
msgid "table.labelNoRows"
msgstr "Sorry, no results match your search"

#. js-lingui-explicit-id
#: src/pages/DailyReport/TabInformations/index.tsx:46
msgid "snapshot.databases"
msgstr "Database"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:130
msgid "safesend.dailyStats.excludedEmails"
msgstr "Excluded email addresses"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:134
msgid "safesend.dailyStats.suspiciousActions"
msgstr "Suspicious actions"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:156
#: src/pages/SafeSend/index.tsx:174
msgid "safesend.databaseStats.fromDate"
msgstr "Activated from {date}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:165
msgid "safesend.databaseStats.untilDate"
msgstr "Activated until {date}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:186
msgid "safesend.databaseStats.dateRange"
msgstr "From {startDate} to {endDate}"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:194
msgid "safesend.cards.emails.title"
msgstr "Excluded email addresses"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:195
msgid "safesend.cards.emails.description"
msgstr "{data} email addresses have been excluded from your mailings."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:204
msgid "safesend.cards.actions.title"
msgstr "Suspicious actions"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:205
msgid "safesend.cards.actions.description"
msgstr "The actions of {data} suspicious email addresses have been limited in your statistics."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:235
msgid "table.search"
msgstr "Search"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:236
msgid "table.elementsTabCount"
msgstr "elements on my page"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:245
msgid "safesend.title"
msgstr "SafeSend"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:246
msgid "safesend.description"
msgstr "Track the number of email addresses excluded from your mailings and whose actions are limited in your statistics thanks to SafeSend. To learn more about SafeSend, "

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:248
msgid "safesend.descriptionLink"
msgstr "https://serviceclient.mindbaz.com/en/faq/safesend-le-filtre-%C3%A0-emails-dangereux-par-mindbaz"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:257
msgid "safesend.panel.title"
msgstr "Choice of period"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:258
msgid "safesend.panel.period"
msgstr "Period"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:341
msgid "safesend.popup.title"
msgstr "Choice of period"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:346
msgid "safesend.popup.description"
msgstr "To modify the SafeSend offer, please contact an administrator: {adminList}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:107
msgid "snapshot.tabs.general.title"
msgstr "General"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:120
msgid "snapshot.tabs.performance.title"
msgstr "Performance by database"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:152
msgid "snapshot.title"
msgstr "Welcome to your deliverability snapshot !"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:153
msgid "snapshot.description"
msgstr "Consult your email statistics for  <strong>{values}</strong> . In the <strong>General tab</strong>, you’ll find the deliverability alerts that were active on this date and the performance of your databases. If you’d like a detailed view by database, use the <strong>Performance by Database tab</strong>."

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:158
msgid "snapshot.displayStatistics"
msgstr "Display statistics on"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:172
msgid "snapshot.switch_apple_mpp.label"
msgstr "Include"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:176
msgid "snapshot.switch_apple_mpp.link"
msgstr "https://serviceclient.mindbaz.com/en/faq/apple-mail-privacy-protection-mindbaz"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:178
msgid "snapshot.switch_apple_mpp.linkText"
msgstr "Apple MPP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/index.tsx:180
msgid "snapshot.switch_apple_mpp.endLabel"
msgstr "opens"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:5
msgid "features.cards.safesend.title"
msgstr "Automatically filter dangerous emails"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:6
msgid "features.cards.safesend.description"
msgstr "SafeSend is the Mindbaz filter that automatically removes dangerous email addresses from your mailings."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:7
msgid "features.cards.safesend.bafflingProblem"
msgstr "Your email campaigns are impacted by bots, spam complaints, spam traps and disposable emails, all of which lower your deliverability rate and your reputation with ISPs."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:8
msgid "features.cards.safesend.goal"
msgstr "Only send your campaigns to the right addresses and optimize your deliverability effortlessly."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:9
msgid "features.cards.safesend.activateFeature"
msgstr "Activate SafeSend"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:12
msgid "features.cards.dashboards.title"
msgstr "Visualize the performance of all your databases with a global view"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:13
msgid "features.cards.dashboards.description"
msgstr "With Dashboards, you no longer need to leave your email router to analyze all your campaigns."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:14
msgid "features.cards.dashboards.bafflingProblem"
msgstr "To send mass email campaigns, most of our customers use different databases. When the same email campaign is sent to several databases, how do you estimate the overall performance of the campaign on Mailbox Service Providers?"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:15
msgid "features.cards.dashboards.goal"
msgstr "Use a multi-database data visualization tool."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:16
msgid "features.cards.dashboards.activateFeature"
msgstr "30-day free trial"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:19
msgid "features.cards.snapshot.title"
msgstr "Get a daily snapshot of your deliverability"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:20
msgid "features.cards.snapshot.description"
msgstr "Snapshot allows you to anticipate deliverability problems in order to quickly resolve them."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:21
msgid "features.cards.snapshot.bafflingProblem"
msgstr "Agencies that send out mass email campaigns can be subject to deliverability risks and changes in best practices. If you’re checking each campaign individually to try to understand the reason for a drop in deliverability, it’s a waste of time."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:22
msgid "features.cards.snapshot.goal"
msgstr "Save time on analyzing your deliverability on Mailbox Service Providers by taking advantage of a daily snapshot of your deliverability."

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:23
msgid "features.cards.snapshot.activateFeature"
msgstr "30-day free trial"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:28
msgid "safesend.panel.thirtyLastDays"
msgstr "Last 30 days"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:29
msgid "safesend.panel.currentMonth"
msgstr "Current month"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:30
msgid "safesend.panel.lastMonth"
msgstr "Last month"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:31
msgid "safesend.panel.threeLastMonths"
msgstr "Last 3 months"

#. js-lingui-explicit-id
#: src/packages/locales/i18n.ts:32
msgid "safesend.panel.sixLastMonths"
msgstr "Last 6 months"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:321
msgid "snapshot.general.preblockSummary"
msgstr "Mindbaz preblocking"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:322
#: src/pages/DailyReport/useCards.tsx:340
msgid "snapshot.general.preblock.level"
msgstr "Lev. "

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:360
msgid "snapshot.general.blacklistSummary"
msgstr "Blacklist"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:379
msgid "snapshot.general.undelegatedSummary"
msgstr "Domain not delegated"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:447
msgid "{nbPreblock, plural, one {# Mindbaz Preblock} other {# Mindbaz Preblocks}}"
msgstr "{nbPreblock, plural, one {# Mindbaz Preblock} other {# Mindbaz Preblocks}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:457
msgid "snapshot.general.noPreblock"
msgstr "No current Mindbaz preblock"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:465
msgid "{nbBlacklist, plural, one {# Blacklist} other {# Blacklists}}"
msgstr "{nbBlacklist, plural, one {# Blacklist} other {# Blacklists}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:471
msgid "snapshot.general.noBlacklist"
msgstr "No blacklist"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:479
msgid "{nbUndelegated, plural, one {# Undelegated domain} other {# Undelegated domains}}"
msgstr "{nbUndelegated, plural, one {# Undelegated domain} other {# Undelegated domains}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:489
msgid "snapshot.general.noUndelegated"
msgstr "All your domains are delegated"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:497
msgid "snapshot.general.performance"
msgstr "Performance by database"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:544
msgid "snapshot.performance.email"
msgstr "Emails sent by ISPl"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:566
msgid "snapshot.performance.deliverability"
msgstr "Deliverability by ISP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:585
msgid "{nbDeliverabilityAlert, plural, one {# deliverability alert} other {# deliverability alerts}}"
msgstr "{nbDeliverabilityAlert, plural, one {# deliverability alert} other {# deliverability alerts}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:595
msgid "snapshot.performance.noDeliverabilityAlert"
msgstr "No current deliverability alert"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:603
msgid "snapshot.performance.performance"
msgstr "Performance by ISP"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:620
msgid "snapshot.performance.spamVol"
msgstr "Spam complaints (vol.)"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:623
#: src/pages/DailyReport/useCards.tsx:651
msgid "snapshot.performance.noResult"
msgstr "No Spam Complaints On {{date}}"

#. js-lingui-explicit-id
#: src/pages/DailyReport/useCards.tsx:648
msgid "snapshot.performance.spamPercent"
msgstr "Spam complaints (%)"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:154
msgid "features.goal"
msgstr "🎯 Your goal"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:148
msgid "features.bafflingProblem"
msgstr "🤯 The puzzle"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:249
msgid "safesend.descriptionClickHere"
msgstr "click here."

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:325
msgid "safesend.databaseDetails"
msgstr "Details by database"

#. js-lingui-explicit-id
#: src/pages/Features/index.tsx:159
msgid "features.description"
msgstr "Discover the features of Rubixo that are based on the analysis of 16 billion emails routed by Mindbaz every year."

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:88
msgid "feature.footer.learnMore"
msgstr "Find out more about Mindbaz's email audits"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:131
msgid "features.learnMore"
msgstr "Learn more"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:45
msgid "gone_page.link"
msgstr "Learn more about Dashboards"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:31
msgid "page_not_found.button"
msgstr "Login to Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:112
msgid "features.manageOffer"
msgstr "Manage my subscription"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:337
msgid "safesend.updateOffer"
msgstr "Modify my SafeSend offer"

#. js-lingui-explicit-id
#: src/pages/SafeSend/index.tsx:351
msgid "safesend.popup.confirm"
msgstr "Modify my SafeSend offer"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:34
msgid "feature.footer.featureInProgress"
msgstr "More features are on the way."

#. js-lingui-explicit-id
#: src/pages/Common/AccessDenied.tsx:38
msgid "oops"
msgstr "Oops! You don't have access to this platform."

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:31
msgid "gone_page.description1"
msgstr "Snapshot reports are accessible <strong>7 days</strong> after it was published."

#. js-lingui-explicit-id
#: src/pages/Features/index.tsx:151
msgid "features.title"
msgstr "Solve the email deliverability puzzle with Rubixo"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:40
msgid "feature.footer.follow"
msgstr "Stay tuned so you don't miss out!"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:76
msgid "feature.footer.followEmailTraining"
msgstr "Take an email training course with Mindbaz"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:20
msgid "page_not_found.title"
msgstr "This page does not exist"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:25
msgid "gone_page.title"
msgstr "This Snapshot report is no longer available"

#. js-lingui-explicit-id
#: src/pages/Common/Gone.tsx:37
msgid "gone_page.description2"
msgstr "To have a complete view of your sendings, we invite you to discover Dashboards."

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/Footer/index.tsx:66
msgid "feature.footer.optimizeEmail"
msgstr "Want to optimize your email marketing?"

#. js-lingui-explicit-id
#: src/pages/Common/NoFound.tsx:24
msgid "page_not_found.description"
msgstr "We did not find the page you were looking for"

#. js-lingui-explicit-id
#: src/pages/Features/Blocks/FeatureCard/index.tsx:105
msgid "features.freeAccess"
msgstr "You currently have free access"
